import axios from "axios";

export const get = async (url, headers) => {
  return headers ? await axios.get(url, { headers }) : await axios.get(url);
};

export const post = async (url, data, headers) => {
  return headers
    ? await axios.post(url, data, { headers })
    : await axios.post(url, data);
};

export const put = async (url, data, headers) => {
  return headers
    ? await axios.put(url, data, { headers })
    : await axios.put(url, data);
};

export const deleteRequest = async (url, headers) => {
  return headers
    ? await axios.delete(url, { headers })
    : await axios.delete(url);
};
